<template>
  <ul class="uk-grid-match instructions" uk-grid>
    <li class="uk-width-1-3@s">
      <div>
        <settings></settings>

        <button class="uk-button uk-button-primary" @click="changeParams">СТАРТ!</button>
      </div>
    </li>
    <li class="uk-width-2-3@s">
      <div>
        <div class="wh-block__wrap">
          <div class="wh-block__desc" v-html="item.instruction"></div>
          <div class="wh-block__pic"><img v-if="item.inner_image" :src="item.inner_image.path" alt=""></div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex';
import settings from "./components/Settings";

export default {
  name: "instructions",
  inject: [
    'TrainerMethods', 'module_name'
  ],
  components: { settings },
  computed: {
    ...mapState({
      item: 'current_trainer'
    })
  },
  methods: {
    changeParams() {
      this.TrainerMethods.commitVal(true, 'start', this.module_name, this);
    }
  }
}
</script>
